import { render } from "./RatingsPage.vue?vue&type=template&id=55cd8d68&ts=true"
import script from "./RatingsPage.vue?vue&type=script&lang=ts"
export * from "./RatingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__